__turbopack_context__.v({
  "className": "manrope_aa3968b9-module__uLqo8G__className",
  "variable": "manrope_aa3968b9-module__uLqo8G__variable",
});
